import { useEffect, useState } from "react";
import { Claim } from "./Claim";
import { Landing } from "./Landing";

/* The apex has two pages now, so it needs the smallest possible router.

   Two things have to keep working and they pull in opposite directions: the
   invite links already sent out are `/claim?code=…` and must open the form on a
   cold load, while the button on the landing page must not throw away the React
   tree to get there. So the path is read once for the first render and pushed
   for the transition, and popstate puts the back button back where it belongs.

   Not a router library: this is one boolean, and the server already serves the
   shell for every path. */

function isClaimPath(): boolean {
  return location.pathname.replace(/\/+$/, "") === "/claim";
}

export function Public({ baseDomain }: { baseDomain: string }) {
  const [claiming, setClaiming] = useState(isClaimPath);

  useEffect(() => {
    const onPop = () => setClaiming(isClaimPath());
    addEventListener("popstate", onPop);
    return () => removeEventListener("popstate", onPop);
  }, []);

  if (claiming) {
    return (
      <Claim
        baseDomain={baseDomain}
        onBack={() => {
          history.pushState(null, "", "/");
          setClaiming(false);
        }}
      />
    );
  }

  return (
    <Landing
      baseDomain={baseDomain}
      onSetUp={() => {
        // Keep whatever query string is on the URL: somebody who followed a
        // `/?code=…` link and pressed the button still arrives with their code
        // in the field.
        history.pushState(null, "", `/claim${location.search}`);
        setClaiming(true);
        scrollTo(0, 0);
      }}
    />
  );
}
